import React from 'react';
import { Input, Row, Col } from 'antd';

const AssetSearch = ({ assetsData, searchText, setSearchText, setFilteredData }) => {
  const handleSearch = (value) => {
    setSearchText(value);

    const filtered = assetsData.filter((record) => {
      const matchesCode = record.code?.toLowerCase().includes(value.toLowerCase());
      const matchesName = record.name?.toLowerCase().includes(value.toLowerCase());
      const matchesArea = record.area?.name.toLowerCase().includes(value.toLowerCase());
      const matchesCategory = record.category?.name?.toLowerCase().includes(value.toLowerCase());
      const matchesDescription = record.description?.toLowerCase().includes(value.toLowerCase());
      const matchesOwner = record.owner?.toLowerCase().includes(value.toLowerCase());

      return (
        matchesCode || 
        matchesName ||
        matchesArea ||
        matchesCategory ||
        matchesDescription || 
        matchesOwner
      );
    });

    setFilteredData(filtered); 
  };

  const handleReset = () => {
    setSearchText(''); 
    setFilteredData(assetsData);
  };

  return (
    <Row justify="start" style={{ marginBottom: 16 }}>
      <Col>
        <Input.Search
          className="search-table"
          placeholder="Buscar Activos"
          value={searchText}
          onChange={(e) => handleSearch(e.target.value)}
          onSearch={handleSearch}
          allowClear
        />
      </Col>
    </Row>
  );
};

export default AssetSearch;
